import { OptionType } from '@evinced-private/ui-common';

export const removeSelectAllOption = (options?: OptionType[]): OptionType[] =>
	options?.filter((option) => option.value !== '*') ?? [];
